import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "../store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export { useDebounce } from "./debounce";
export { useFacebookAdAccounts } from "./facebook-ad-accounts";
export { useLoading } from "./loading";
export { useToaster } from "./toaster";
export { useWorkspaceURL } from "./workspace-url";
